import { connect } from "react-redux";
import GlobalBanner from "./GlobalBanner";
import {
  getStoreCode,
  getDefaultLanguage,
  getCountryCode
} from "../../state/modules/regionalStore";

import {
  getIdentityHasResponded,
  getIsPremier
} from "../../state/modules/user";

function mapStateToProps(state) {
  return {
    storeCode: getStoreCode(state),
    language: getDefaultLanguage(state),
    identityHasResponded: getIdentityHasResponded(state),
    isPremier: getIsPremier(state),
    browseCountry: getCountryCode(state)
  };
}

export default connect(mapStateToProps)(GlobalBanner);



// WEBPACK FOOTER //
// ./template/components/GlobalBanner/index.js